import { NavigateFunction, } from 'react-router';
import {
  FormElementTypes,
  FormLayoutTypes,
  IForm,
  IFormOptions,
} from 'atlas-form';
import { IAuth, IAbilities, } from '@Store';
import { CrudEnum, PermissionEnum, ISharedUpdateDestinationRestrictor, ISharedDestinationRestrictor, IPreviewOrganization, } from 'atlas-shared';
import { TFunction, } from 'i18next';
import { nestedArray, entitiesToOptions, onFormSaved, } from '@Utils';

export interface IDestinationRestrictorFormOptionsProps {
  t: TFunction;
  is_new: boolean;
  abilities: IAbilities;
  organizations: Array<IPreviewOrganization>;
}

export const DestinationRestrictorFormOptions = (destination_restrictor: ISharedDestinationRestrictor, props: IDestinationRestrictorFormOptionsProps, t: TFunction): IFormOptions => ({
  organization_id: entitiesToOptions<IPreviewOrganization>(nestedArray<any>(props.organizations.filter(organization => props.abilities.can(organization.id, CrudEnum.Insert, PermissionEnum.DestinationRestrictor, {})), 'organization_id', false), 'organization'),
  
});

export const DestinationRestrictorComponents: IForm['components'] = {};
export const DestinationRestrictorAdditionalParams: (auth: IAuth, props: IDestinationRestrictorFormOptionsProps) => IForm['additionalParams'] = (auth: IAuth, props: IDestinationRestrictorFormOptionsProps) => ({
});

export const DestinationRestrictorEditForm = (destination_restrictor: ISharedDestinationRestrictor, props: IDestinationRestrictorFormOptionsProps, t: TFunction, label?: string): IForm => ({
  id: `destination_restrictor_edit_${destination_restrictor.id}`,
  label: label,
  ui_layout: FormLayoutTypes.HORIZONTAL,
  elements: [
    { ui_type: FormElementTypes.PREVIEW, preview_value: props.organizations.find(it => it.id === destination_restrictor.organization_id)?.title, path: 'organization_id', shouldUpdate: () => false, },
    { ref: 'destinations', },
  ],
});

export const DestinationRestrictorEditInitialValues = (destination_restrictor: ISharedDestinationRestrictor): ISharedUpdateDestinationRestrictor => ({
  destinations: destination_restrictor.destinations,
});

export const onDestinationRestrictorFormSaved = (t: TFunction, action: 'edit' | 'add', destination_restrictor: ISharedDestinationRestrictor, navigate: NavigateFunction): void => {
  navigate(onFormSaved('destination_restrictors'));
};
